module.exports = __webpack_public_path__ + "static/media/JP.1bea37fd.png";